import React from "react";
import {
  FaBuilding,
  FaMapMarkerAlt,
  FaCity,
  FaIdCard,
  FaEnvelope,
  FaPhoneAlt,
  FaLayerGroup,
} from "react-icons/fa";
import "../styles/BusinessDetails.css";
import formatMobileNumber from "../_utils/formatMobileNumber";

import { toBoolean } from "../_utils/to.boolean";

export default function BusinessDetails({ tenant }) {
  if (!tenant) {
    return (
      <div className="container py-5">
        <div className="alert alert-warning">
          Business details not available.
        </div>
      </div>
    );
  }

  const initials = tenant.businessName
    ?.split(" ")
    .map((x) => x[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  const active = tenant.subscriptions.find(
    sub => sub.isActive === 1
  );
  
  const subscriptionHistory = tenant.subscriptions.filter(
    sub => sub.isActive === 0 && sub.status !== "Pending"
  );
  
  const pending = tenant.subscriptions.find(
    sub => sub.status === "Pending"
  );
  
  return (
    <div className="business-details-page">

      <div className="business-header shadow">
        <div className="business-avatar">
          {initials}
        </div>

        <div className="business-header-info">
          <h2>{tenant.businessName}</h2>
          <span className="solution-badge">
            {
              active
              ? `${active.productName} - ${active.planName}`
              : "No active Subscription"
            }
          </span>
        </div>
      </div>

      <div className="row g-4 mt-1">

        <div className="col-lg-6">
          <div className="business-card">

            <div className="card-title">
              Business Information
            </div>

            <BusinessItem
              icon={<FaBuilding />}
              label="Business Name"
              value={tenant.businessName}
            />

            <BusinessItem
              icon={<FaIdCard />}
              label="Registration Number"
              value={tenant.registrationNumber}
            />

            <BusinessItem
              icon={<FaLayerGroup />}
              label="Subscribed To"
              value=
                {
                  active
                  ? `${active.productName} - ${active.planName}`
                  : "No active Subscription"
                }
            />

          </div>
        </div>

        <div className="col-lg-6">
          <div className="business-card">

            <div className="card-title">
              Contact Information
            </div>

            <BusinessItem
              icon={<FaMapMarkerAlt />}
              label="Physical Address"
              value={tenant.physicalAddress}
            />

            <BusinessItem
              icon={<FaCity />}
              label="City"
              value={tenant.city}
            />

            <BusinessItem
              icon={<FaEnvelope />}
              label="Email Address"
              value={tenant.emailAddress}
            />

            <BusinessItem
              icon={<FaPhoneAlt />}
              label="Mobile Number"
              value={formatMobileNumber(tenant.mobileNumber)}
            />

          </div>
        </div>

      </div>

    </div>
  );
}

function BusinessItem({ icon, label, value}) {
  return (
    <div className="business-item">
      <div className="business-icon">
        {icon}
      </div>

      <div className="business-content">
        <small>{label}</small>
        <h6>{value || "-"}</h6>
      </div>
    </div>
  );
}